/* eslint-disable zillow/@typescript-eslint/naming-convention */

export interface URLParams {
    protocol: string;
    host: string;
    port: string;
}

export interface SharedSessionData {
    zipcode?: number;
    city?: string;
    regionId?: number;
    centroid?: { lat: number; lon: number };
}

export interface CollectionTrackingItem {
    zpid: number;
    rec_rank: number;
}

export interface GenericCollection {
    collection_type_txt: string;
    collection_title_txt: string;
    collection_data: {
        module_rank_nb: number;
        tracing_id: string;
    };
    collection_items: CollectionTrackingItem[] | [];
}

export enum AllHopsPlacements {
    HOME_PAGE_HERO_IMAGE = 'HomePageHeroImage',
    HOME_PAGE_RTB_CARD_1 = 'HomePageRTBCard1',
    HOME_PAGE_RTB_CARD_2 = 'HomePageRTBCard2',
    HOME_PAGE_RTB_CARD_3 = 'HomePageRTBCard3',
    HOME_PAGE_BANNER = 'HomePageBanner',
}
